import React from 'react';
import InitialHome from '../components/InitialHome';
// import ServiceCard from '../components/ServiceCard';
import '../assets/styles/Home.css';
import ContadorAnimado from '../components/ContadorAnimado';

// import heroImg from '../assets/images/hero-background.webp';
import heroImgplaca from '../assets/images/placa-solar-painel-modulo-fotovoltaico-330wp.jpg';

// import jardimEuropa from '../assets/images/jardim-europa.png';
// import alphaville from '../assets/images/alphaville.png';
// import jardimMariaHelena from '../assets/images/jardim-maria-helena.png';
// import bonfinopolis from '../assets/images/bonfinopolis.png';
// import rioDosBois from '../assets/images/rio-dos-bois.png';
// import trindade from '../assets/images/trindade.png';
import antesTalao from "../assets/images/antes.webp";
import depoisTalao from "../assets/images/depois.webp";

import { ReactComponent as IconEconomia } from '../assets/icons/economia.svg';
import { ReactComponent as IconValorizacaoImovel } from '../assets/icons/valorizacao-imovel.svg';
import { ReactComponent as IconSustentavel } from '../assets/icons/sustentavel.svg';
import Section from '../components/Section';
import Carousel from '../components/Carousel';

// type ServiceItem = {
//   title: string;
//   description: string;
//   image: string;
//   iframe?: string; // opcional: use se quiser mostrar simulador no modal
// };

// const services: ServiceItem[] = [
//   { title: "Jardim Europa", description: "GOIÂNIA.", image: jardimEuropa, iframe: "https://azume.com.br/simulador/660eb64ef616890015bca9c8" },
//   { title: "Alphaville", description: "GOIÂNIA.", image: alphaville },
//   { title: "JD Maria Helena", description: "GOIÂNIA.", image: jardimMariaHelena },
//   { title: "Bonfinopolis", description: "45 kWp.", image: bonfinopolis },
//   { title: "Rio Dos Bois", description: "60 kWp.", image: rioDosBois },
//   { title: "Trindade", description: "65 kWp.", image: trindade },
// ];

import SajeImg from "../assets/images/saje.png";
import GoodweImg from "../assets/images/goodwe.png";
import IntelbrasImg from "../assets/images/intelbras.png";
import SungrowImg from "../assets/images/sungrow.png";
import SolisImg from "../assets/images/solis.png";
import { Inverter } from './Produtos';
import { Link } from 'react-router-dom';

const INVERTERS: Inverter[] = [
  {
    id: "inv-saje-1",
    brand: "Saje",
    model: "SJA-5K",
    image: SajeImg,
    description: "Linha residencial eficiente com monitoramento por app.",
    specs: {
      potenciaSaida: "5 kW monofásico",
      mppt: "2 MPPT",
      eficiencia: "98.0%",
      tensaoEntrada: "120–600 V",
      protecoes: "AFCI, SPD, sobrecorrente",
      comunicacao: "Wi-Fi / App",
      grauProtecao: "IP65",
      garantia: "5 anos"
    }
  },
  {
    id: "inv-goodwe-1",
    brand: "Goodwe",
    model: "GW10K-ET",
    image: GoodweImg,
    description: "Série trifásica com ótima relação custo/benefício.",
    specs: {
      potenciaSaida: "10 kW trifásico",
      mppt: "2 MPPT",
      eficiencia: "98.3%",
      tensaoEntrada: "180–1000 V",
      protecoes: "AFCI, SPD, anti-ilhamento",
      comunicacao: "Wi-Fi / RS-485 / SEMS",
      grauProtecao: "IP65",
      garantia: "10 anos (países selecionados)"
    }
  },
  {
    id: "inv-intelbras-1",
    brand: "Intelbras",
    model: "IHV-6K",
    image: IntelbrasImg,
    description: "Integração nacional e assistência ampla.",
    specs: {
      potenciaSaida: "6 kW monofásico",
      mppt: "2 MPPT",
      eficiencia: "98.1%",
      tensaoEntrada: "120–600 V",
      protecoes: "SPD CC/CA, sobretemp.",
      comunicacao: "Wi-Fi / App",
      grauProtecao: "IP65",
      garantia: "7 anos (Brasil)"
    }
  },
  {
    id: "inv-sungrow-1",
    brand: "Sungrow",
    model: "SG10RT",
    image: SungrowImg,
    description: "Alta eficiência e robustez reconhecida no mercado.",
    specs: {
      potenciaSaida: "10 kW trifásico",
      mppt: "3 MPPT",
      eficiencia: "98.6%",
      tensaoEntrada: "150–1000 V",
      protecoes: "AFCI, SPD Tipo II",
      comunicacao: "Wi-Fi / Ethernet / iSolarCloud",
      grauProtecao: "IP65",
      garantia: "10 anos"
    }
  },
  {
    id: "inv-solis-1",
    brand: "Solis",
    model: "S5-GR1P(6)K",
    image: SolisImg,
    description: "Boa performance com interface simples.",
    specs: {
      potenciaSaida: "6 kW monofásico",
      mppt: "2 MPPT",
      eficiencia: "98.4%",
      tensaoEntrada: "90–600 V",
      protecoes: "AFCI, SPD, rele anti-ilhamento",
      comunicacao: "Wi-Fi / RS-485",
      grauProtecao: "IP66",
      garantia: "10 anos"
    }
  }
];

const WHATSAPP_URL = 'https://wa.me/5562981368378';

const FAQ_ITEMS = [
  { question: 'Quanto posso economizar com energia solar?', answer: 'A economia varia conforme o consumo, a tarifa e o tamanho do sistema. Em muitos projetos residenciais, a redução chega a 90% da conta de energia.' },
  { question: 'Quanto custa instalar energia solar?', answer: 'O investimento depende do consumo mensal, do telhado e do tipo de equipamento. A MDA faz uma avaliação personalizada e apresenta uma simulação antes da decisão.' },
  { question: 'Em quanto tempo o sistema solar se paga?', answer: 'O retorno costuma acontecer em alguns anos, mas depende da tarifa, do consumo e da incidência solar. A simulação mostra o prazo estimado para cada imóvel.' },
  { question: 'A energia solar funciona em dias nublados?', answer: 'Sim. Os painéis continuam gerando energia mesmo com céu nublado, embora a produção seja menor. O dimensionamento considera o histórico solar da região.' },
  { question: 'A MDA atende casas e empresas?', answer: 'Sim. Desenvolvemos projetos para residências, comércios, condomínios e empresas em Goiás, com instalação e acompanhamento especializado.' },
];

type SimulationModalProps = { onClose: () => void };

const SimulationModal: React.FC<SimulationModalProps> = ({ onClose }) => {
  const [step, setStep] = React.useState(1);
  const [profile, setProfile] = React.useState('');
  const [billRange, setBillRange] = React.useState('');
  const [calculatorKey, setCalculatorKey] = React.useState(0);

  const reset = () => {
    setStep(1);
    setProfile('');
    setBillRange('');
    setCalculatorKey(value => value + 1);
  };

  return (
    <div className="simulation-modal-backdrop" role="presentation" onMouseDown={event => event.target === event.currentTarget && onClose()}>
      <div className="simulation-modal" role="dialog" aria-modal="true" aria-labelledby="simulation-title">
        <div className="simulation-modal-header">
          <div><span className="simulation-kicker">SIMULAÇÃO DE ECONOMIA</span><h2 id="simulation-title">{step === 4 ? 'Sua simulação está pronta' : 'Vamos entender o seu consumo'}</h2></div>
          <button className="simulation-close" type="button" onClick={onClose} aria-label="Fechar simulação">×</button>
        </div>
        {step < 4 ? <div className="simulation-guide">
          <div className="simulation-progress"><span style={{ width: `${step * 33.33}%` }} /></div>
          {step === 1 && <><p className="simulation-question">Onde você quer instalar energia solar?</p><div className="simulation-options">{['Minha casa', 'Minha empresa'].map(option => <button type="button" key={option} onClick={() => { setProfile(option); setStep(2); }}>{option}</button>)}</div></>}
          {step === 2 && <><p className="simulation-question">Qual é a média da sua conta de energia?</p><div className="simulation-options">{['Até R$ 300', 'R$ 300 a R$ 700', 'Acima de R$ 700'].map(option => <button type="button" key={option} onClick={() => { setBillRange(option); setStep(3); }}>{option}</button>)}</div></>}
          {step === 3 && <><p className="simulation-question">Ótimo. Já temos um ponto de partida.</p><div className="simulation-summary"><strong>{profile}</strong><span>Conta média: {billRange}</span><small>Agora você pode detalhar o resultado no simulador completo.</small></div><button className="simulation-primary" type="button" onClick={() => setStep(4)}>Abrir simulador completo ↗</button><button className="simulation-back" type="button" onClick={() => setStep(2)}>Voltar e ajustar</button></>}
        </div> : <div className="simulation-calculator"><div className="simulation-calculator-actions"><button type="button" onClick={reset}>↻ Refazer simulação</button><span>Preencha os dados para ver seu potencial de economia.</span></div><iframe key={calculatorKey} src="https://azume.com.br/simulador/660eb64ef616890015bca9c8" width="100%" height="620" style={{ border: 'none' }} title="Simulador de economia de energia solar" loading="lazy" allowFullScreen /></div>}
      </div>
    </div>
  );
};

const Home: React.FC = () => {
  const [simulationOpen, setSimulationOpen] = React.useState(false);
  
  return (
    <div className="home-page no-offset">
      <InitialHome
        title="Economize com energia solar"
        subtitle={`R\neduza sua conta de energia em até 90% e transforme essa economia em investimento para o seu futuro!`}
        subtitleTexto={``}
        backgroundImage={heroImgplaca}
      />
      

      {/* KPIs abaixo do herói */}
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 color-secondary gap-8">
      <div className="stats-block">
          <div className="header-stats">
            <div className="stat-item">
              <strong>+ de <ContadorAnimado final={340} /></strong> clientes felizes
            </div>
            <div className="stat-item">
              <strong>+ de <ContadorAnimado final={358} /></strong> instalações
            </div>
            <div className="stat-item">
              <strong>+ de <ContadorAnimado final={2184} suffix=" kW" /></strong> instalados
            </div>
          </div>
        </div>
        </div>
      

      {/* Benefícios */}
      <Section className="services-section" id="beneficios">
        <div className="container text-center">
          <h2 className="section-title">Por que escolher energia solar?</h2>

          <div className="benefits-grid">
            <Link to="/blog/economia-na-conta-de-luz" className="benefit-card">
              <IconEconomia className="benefit-icon" width="100" height="100" />
              <h3 className="benefit-title">Economia de até 90%</h3>
              <p className="benefit-text">
                Reduza drasticamente sua conta de luz e recupere o investimento em poucos anos.
              </p>
              <span className="benefit-read">Leia no blog <span aria-hidden="true">↗</span></span>
            </Link>

            <Link to="/blog/energia-solar-sustentavel" className="benefit-card">
              <IconSustentavel className="benefit-icon" width="100" height="100" />
              <h3 className="benefit-title">Energia limpa</h3>
              <p className="benefit-text">
                Contribua com o meio ambiente usando uma fonte de energia renovável.
              </p>
              <span className="benefit-read">Leia no blog <span aria-hidden="true">↗</span></span>
            </Link>

            <Link to="/blog/energia-solar-valoriza-imovel" className="benefit-card">
              <IconValorizacaoImovel className="benefit-icon" width="100" height="100" />
              <h3 className="benefit-title">Valorização do imóvel</h3>
              <p className="benefit-text">
                Imóveis com energia solar são mais valorizados e atrativos.
              </p>
              <span className="benefit-read">Leia no blog <span aria-hidden="true">↗</span></span>
            </Link>
          </div>
          <div className="pain-cta">
            <div><span>SE A CONTA DE LUZ SÓ AUMENTA, ESTÁ NA HORA DE MUDAR</span><h3>Quanto você poderia economizar todos os meses?</h3><p>Faça uma simulação rápida e descubra se sua casa ou empresa está pronta para gerar a própria energia.</p></div>
            <button type="button" className="hero-cta" onClick={() => setSimulationOpen(true)}>Calcular minha economia ↗</button>
          </div>
        </div>
      </Section>

      {/* Antes x Depois + CTA */}
      <Section className="bg-gray-50 text-center benefits-section" id="economia">
        <span className="economy-kicker">ANTES E DEPOIS DA ENERGIA SOLAR</span>
        <h2 className="section-title">Veja sua conta cair de R$ 346 para R$ 36</h2>
        <p className="economy-intro">Um exemplo real de como uma família reduziu a conta de energia e passou a economizar todos os meses.</p>

        <div className="cards-2col">
          <div className="card">
            <div>
              <h3 className="card-title">ANTES</h3>
              <p className="card-sub">
                Valor da conta antes da energia solar: <strong>R$ 346,20</strong>
              </p>
              <img
                src={antesTalao}
                alt="Conta de energia antes da instalação de energia solar"
                className="card-img"
                loading="lazy"
              />
            </div>
            {/* <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-whats"
            >
              QUERO ECONOMIZAR
            </a> */}
          </div>

          <div className="card">
            <div>
              <h3 className="card-title">DEPOIS</h3>
              <p className="card-sub">
                Valor da conta depois da energia solar: <strong>R$ 36,05</strong>
              </p>
              <img
                src={depoisTalao}
                alt="Conta de energia após a instalação de energia solar"
                className="card-img"
                loading="lazy"
              />
            </div>
            {/* <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-whats"
            >
              QUERO ECONOMIZAR
            </a> */}
          </div>
        </div>
        <div className="economy-result" aria-label="Economia mensal estimada">
          <span className="economy-result-label">ECONOMIA MENSAL NO EXEMPLO</span>
          <strong>R$ 310,15</strong>
          <span>ou 89,6% a menos na conta de energia</span>
        </div>
        <div className="simulation-launch">
          <span>Quer uma estimativa para o seu imóvel?</span>
          <button type="button" className="simulation-launch-button" onClick={() => setSimulationOpen(true)}>Começar minha simulação ↗</button>
        </div>
        {simulationOpen && <SimulationModal onClose={() => setSimulationOpen(false)} />}

        {/* CTA única (removi o duplicado) */}
        {/* <Button
          text="  FAÇA UMA SIMULAÇÃO"
          href="https://azume.com.br/institucional/660eb64ef616890015bca9c8"
          icon={<i className="fa-solid fa-share-from-square" />}
          className="whatsapp-button mt-6"
        /> */}
      </Section>

      <section className="faq-section" id="faq">
        <div className="container">
          <div className="faq-heading">
            <span className="hero-eyebrow">DÚVIDAS FREQUENTES</span>
            <h2 className="section-title">Energia solar sem complicação</h2>
            <p>Respostas diretas para as perguntas que mais recebemos sobre economia, instalação e retorno do investimento.</p>
          </div>
          <div className="faq-list">
            {FAQ_ITEMS.map((item) => <details className="faq-item" key={item.question}>
              <summary>{item.question}<span aria-hidden="true">+</span></summary>
              <p>{item.answer}</p>
            </details>)}
          </div>
          <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
            '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: FAQ_ITEMS.map(item => ({ '@type': 'Question', name: item.question, acceptedAnswer: { '@type': 'Answer', text: item.answer } }))
          }) }} />
        </div>
      </section>

      {/* Serviços / Projetos */}
      <section className="services-section home-products-section">
        <div className="container">
          <span className="products-kicker">EQUIPAMENTOS DE ALTA PERFORMANCE</span>
          <h2 className="section-title center">Conheça nossos inversores solares</h2>
          <p className="products-intro">Tecnologia, segurança e eficiência para gerar mais economia na sua casa ou empresa.</p>

      {/* <div
        role="button"
        tabIndex={0}
        onClick={() => setSelected()}
        onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && setSelected()}
        className="outline-none"
      >
        <ServiceCard
          key="Jardim Europa"
          title="Jardim Europa"
          description="GOIÂNIA."
          image={jardimEuropa}
          link="/protecao-inteligente"
        />
      </div> */}

          {/* <div className="services-grid">
            <ServiceCard title="Jardim Europa" description="GOIÂNIA." image={jardimEuropa} link="/protecao-inteligente" />
            <ServiceCard title="Alphaville" description="GOIÂNIA." image={alphaville} link="/energia-fotovoltaica" />
            <ServiceCard title="JD Maria Helena" description="GOIÂNIA." image={jardimMariaHelena} link="/projetos-eletricos" />
            <ServiceCard title="Bonfinopolis" description="45 kWp." image={bonfinopolis} link="/ar-condicionado" />
            <ServiceCard title="Rio Dos Bois" description="60 kWp." image={rioDosBois} link="/casa-inteligente" />
            <ServiceCard title="Trindade" description="65 kWp." image={trindade} link="/casa-inteligente" />
          </div> */}
        </div>
      </section>

      {/* Inversores */}
  <Carousel
  items={INVERTERS}
  perView={{ sm: 1, md: 2, lg: 3 }}
  gap={18}
  maxWidth={1100}
  className="home-products-carousel"
  itemClassName="centered-slide"
  ariaLabel="Carrossel de inversores"
  autoplayMs={4000}
  renderItem={(item: Inverter) => {
    return (
      <Link
        to={`/produtos/`}
        className="product-card"
        aria-label={`${item.brand} ${item.model ?? ""}`}
      >
             
        <div className="product-image">
          <img
            src={item.image}
            alt={`${item.brand} ${item.model ?? ""}`}
            loading="lazy"
          />
        </div>
        <h3 className="product-title">
          {item.brand} {item.model && `• ${item.model}`}
        </h3>
        {item.description && <p className="product-desc">{item.description}</p>}
        <span className="product-card-cta">Ver detalhes do equipamento ↗</span>
      </Link>
    );
  }}
/>




      {/* CTA final */}
      <section className="cta-section">
        <div className="container">
          <h2 className="section-title center">Transforme sua casa ou empresa</h2>
          <p>Entre em contato para uma avaliação personalizada das suas necessidades.</p>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-button"
            aria-label="Fale conosco pelo WhatsApp"
          >
            <i className="fab fa-whatsapp" /> Fale conosco pelo WhatsApp
          </a>
          <a
  className="whats-fab"
  href="https://wa.me/556232949182"
  target="_blank"
  rel="noreferrer"
  aria-label="WhatsApp"
>
  <div className="whats-chat">
    <div className="whats-header">WhatsApp</div>
    <div className="whats-body">
      <p>👋 Olá! Entrar em contato com um de nossos especialistas</p>
    </div>
  </div>

  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width="28"
    height="28"
    fill="currentColor"
  >
    <path d="M16 0C7.163 0 0 6.99 0 15.615c0 2.755.765 5.393 2.212 7.705L0 32l8.99-2.35c2.44 1.333 5.2 2.04 8.01 2.04 8.837 0 16-6.99 16-15.615C33 6.99 24.837 0 16 0zm0 29.333c-2.49 0-4.92-.653-7.054-1.89l-.505-.29-5.328 1.393 1.426-5.086-.33-.522c-1.324-2.082-2.023-4.49-2.023-6.992 0-7.164 6.09-13 13.5-13 7.41 0 13.5 5.836 13.5 13 0 7.165-6.09 13-13.5 13zm7.374-9.75c-.405-.2-2.386-1.176-2.755-1.309-.37-.133-.64-.2-.91.2-.27.398-1.045 1.308-1.28 1.576-.235.267-.47.3-.874.1-.405-.2-1.71-.629-3.26-2.002-1.205-1.067-2.015-2.388-2.25-2.787-.235-.398-.025-.614.176-.813.18-.177.405-.46.61-.69.2-.23.27-.397.405-.664.135-.266.07-.498-.035-.698-.105-.2-.91-2.177-1.245-2.985-.33-.798-.675-.69-.91-.704l-.775-.014c-.27 0-.71.1-1.08.498-.37.398-1.41 1.376-1.41 3.35s1.445 3.887 1.646 4.155c.2.266 2.84 4.48 6.89 6.086.962.416 1.71.664 2.295.851.962.306 1.84.262 2.535.159.775-.116 2.386-.974 2.725-1.913.335-.94.335-1.745.235-1.913-.095-.164-.37-.266-.775-.466z"/>
  </svg>
</a>

        </div>
      </section>
    </div>
  );
};

export default Home;
